import { getUserEmail } from "../getUserEmail";
import type { SelectionGoal } from "../../../models/eplex/Selection";

// Цели запущенных процессов подбора (procurement/tender) храним ПО ПОЛЬЗОВАТЕЛЯМ
// (как историю поиска): `${BASE_KEY}.<email>`. Так процессы одного аккаунта не видны
// другому на одной машине; при логауте чистить ничего не нужно.
const BASE_KEY = "eplex-selection-goals";

function getGoalsKey(): string {
  const email = getUserEmail();
  return email ? `${BASE_KEY}.${email}` : BASE_KEY;
}

// одноразовый перенос старого общего ключа в ключ текущего пользователя (как в истории поиска)
export function migrateSelectionGoalsIfNeeded(): void {
  const email = getUserEmail();
  if (!email) return;

  const legacy = localStorage.getItem(BASE_KEY);
  if (legacy === null) return;

  const userKey = `${BASE_KEY}.${email}`;
  if (localStorage.getItem(userKey) === null) {
    localStorage.setItem(userKey, legacy);
  }
  localStorage.removeItem(BASE_KEY);
}

export function getSavedSelectionGoals(): Record<string, SelectionGoal> {
  try {
    migrateSelectionGoalsIfNeeded();
    const raw = localStorage.getItem(getGoalsKey());
    return raw ? (JSON.parse(raw) as Record<string, SelectionGoal>) : {};
  } catch (error) {
    console.error("Failed to read selection goals: ", error);
    return {};
  }
}

export function saveSelectionGoals(map: Record<string, SelectionGoal>): void {
  try {
    localStorage.setItem(getGoalsKey(), JSON.stringify(map));
  } catch (error) {
    console.error("Failed to save selection goals: ", error);
  }
}
